import { a as U } from "./chunk-BaseElement-BuXbltG-.js";
import { l as M } from "./chunk-locationStorage-Dt0opuo9.js";
import { W as x } from "./chunk-WithApiClient-Da1nY1F5.js";
function D(h, t, e, o) {
  function r(i) {
    return i instanceof e ? i : new e(function(s) {
      s(i);
    });
  }
  return new (e || (e = Promise))(function(i, s) {
    function n(c) {
      try {
        l(o.next(c));
      } catch (d) {
        s(d);
      }
    }
    function a(c) {
      try {
        l(o.throw(c));
      } catch (d) {
        s(d);
      }
    }
    function l(c) {
      c.done ? i(c.value) : r(c.value).then(n, a);
    }
    l((o = o.apply(h, [])).next());
  });
}
function G(h) {
  return h && h.__esModule && Object.prototype.hasOwnProperty.call(h, "default") ? h.default : h;
}
var H = function h(t, e) {
  if (t === e) return !0;
  if (t && e && typeof t == "object" && typeof e == "object") {
    if (t.constructor !== e.constructor) return !1;
    var o, r, i;
    if (Array.isArray(t)) {
      if (o = t.length, o != e.length) return !1;
      for (r = o; r-- !== 0; )
        if (!h(t[r], e[r])) return !1;
      return !0;
    }
    if (t.constructor === RegExp) return t.source === e.source && t.flags === e.flags;
    if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === e.valueOf();
    if (t.toString !== Object.prototype.toString) return t.toString() === e.toString();
    if (i = Object.keys(t), o = i.length, o !== Object.keys(e).length) return !1;
    for (r = o; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(e, i[r])) return !1;
    for (r = o; r-- !== 0; ) {
      var s = i[r];
      if (!h(t[s], e[s])) return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}, R = /* @__PURE__ */ G(H);
const O = "__googleMapsScriptId";
var I;
(function(h) {
  h[h.INITIALIZED = 0] = "INITIALIZED", h[h.LOADING = 1] = "LOADING", h[h.SUCCESS = 2] = "SUCCESS", h[h.FAILURE = 3] = "FAILURE";
})(I || (I = {}));
class v {
  /**
   * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
   * using this library, instead the defaults are set by the Google Maps
   * JavaScript API server.
   *
   * ```
   * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
   * ```
   */
  constructor({ apiKey: t, authReferrerPolicy: e, channel: o, client: r, id: i = O, language: s, libraries: n = [], mapIds: a, nonce: l, region: c, retries: d = 3, url: u = "https://maps.googleapis.com/maps/api/js", version: g }) {
    if (this.callbacks = [], this.done = !1, this.loading = !1, this.errors = [], this.apiKey = t, this.authReferrerPolicy = e, this.channel = o, this.client = r, this.id = i || O, this.language = s, this.libraries = n, this.mapIds = a, this.nonce = l, this.region = c, this.retries = d, this.url = u, this.version = g, v.instance) {
      if (!R(this.options, v.instance.options))
        throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify(v.instance.options)}`);
      return v.instance;
    }
    v.instance = this;
  }
  get options() {
    return {
      version: this.version,
      apiKey: this.apiKey,
      channel: this.channel,
      client: this.client,
      id: this.id,
      libraries: this.libraries,
      language: this.language,
      region: this.region,
      mapIds: this.mapIds,
      nonce: this.nonce,
      url: this.url,
      authReferrerPolicy: this.authReferrerPolicy
    };
  }
  get status() {
    return this.errors.length ? I.FAILURE : this.done ? I.SUCCESS : this.loading ? I.LOADING : I.INITIALIZED;
  }
  get failed() {
    return this.done && !this.loading && this.errors.length >= this.retries + 1;
  }
  /**
   * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
   *
   * @ignore
   * @deprecated
   */
  createUrl() {
    let t = this.url;
    return t += "?callback=__googleMapsCallback&loading=async", this.apiKey && (t += `&key=${this.apiKey}`), this.channel && (t += `&channel=${this.channel}`), this.client && (t += `&client=${this.client}`), this.libraries.length > 0 && (t += `&libraries=${this.libraries.join(",")}`), this.language && (t += `&language=${this.language}`), this.region && (t += `&region=${this.region}`), this.version && (t += `&v=${this.version}`), this.mapIds && (t += `&map_ids=${this.mapIds.join(",")}`), this.authReferrerPolicy && (t += `&auth_referrer_policy=${this.authReferrerPolicy}`), t;
  }
  deleteScript() {
    const t = document.getElementById(this.id);
    t && t.remove();
  }
  /**
   * Load the Google Maps JavaScript API script and return a Promise.
   * @deprecated, use importLibrary() instead.
   */
  load() {
    return this.loadPromise();
  }
  /**
   * Load the Google Maps JavaScript API script and return a Promise.
   *
   * @ignore
   * @deprecated, use importLibrary() instead.
   */
  loadPromise() {
    return new Promise((t, e) => {
      this.loadCallback((o) => {
        o ? e(o.error) : t(window.google);
      });
    });
  }
  importLibrary(t) {
    return this.execute(), google.maps.importLibrary(t);
  }
  /**
   * Load the Google Maps JavaScript API script with a callback.
   * @deprecated, use importLibrary() instead.
   */
  loadCallback(t) {
    this.callbacks.push(t), this.execute();
  }
  /**
   * Set the script on document.
   */
  setScript() {
    var t, e;
    if (document.getElementById(this.id)) {
      this.callback();
      return;
    }
    const o = {
      key: this.apiKey,
      channel: this.channel,
      client: this.client,
      libraries: this.libraries.length && this.libraries,
      v: this.version,
      mapIds: this.mapIds,
      language: this.language,
      region: this.region,
      authReferrerPolicy: this.authReferrerPolicy
    };
    Object.keys(o).forEach(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (i) => !o[i] && delete o[i]
    ), !((e = (t = window == null ? void 0 : window.google) === null || t === void 0 ? void 0 : t.maps) === null || e === void 0) && e.importLibrary || ((i) => {
      let s, n, a, l = "The Google Maps JavaScript API", c = "google", d = "importLibrary", u = "__ib__", g = document, p = window;
      p = p[c] || (p[c] = {});
      const f = p.maps || (p.maps = {}), m = /* @__PURE__ */ new Set(), y = new URLSearchParams(), k = () => (
        // @ts-ignore
        s || (s = new Promise((L, S) => D(this, void 0, void 0, function* () {
          var b;
          yield n = g.createElement("script"), n.id = this.id, y.set("libraries", [...m] + "");
          for (a in i)
            y.set(a.replace(/[A-Z]/g, (A) => "_" + A[0].toLowerCase()), i[a]);
          y.set("callback", c + ".maps." + u), n.src = this.url + "?" + y, f[u] = L, n.onerror = () => s = S(Error(l + " could not load.")), n.nonce = this.nonce || ((b = g.querySelector("script[nonce]")) === null || b === void 0 ? void 0 : b.nonce) || "", g.head.append(n);
        })))
      );
      f[d] ? console.warn(l + " only loads once. Ignoring:", i) : f[d] = (L, ...S) => m.add(L) && k().then(() => f[d](L, ...S));
    })(o);
    const r = this.libraries.map((i) => this.importLibrary(i));
    r.length || r.push(this.importLibrary("core")), Promise.all(r).then(() => this.callback(), (i) => {
      const s = new ErrorEvent("error", { error: i });
      this.loadErrorCallback(s);
    });
  }
  /**
   * Reset the loader state.
   */
  reset() {
    this.deleteScript(), this.done = !1, this.loading = !1, this.errors = [], this.onerrorEvent = null;
  }
  resetIfRetryingFailed() {
    this.failed && this.reset();
  }
  loadErrorCallback(t) {
    if (this.errors.push(t), this.errors.length <= this.retries) {
      const e = this.errors.length * Math.pow(2, this.errors.length);
      console.error(`Failed to load Google Maps script, retrying in ${e} ms.`), setTimeout(() => {
        this.deleteScript(), this.setScript();
      }, e);
    } else
      this.onerrorEvent = t, this.callback();
  }
  callback() {
    this.done = !0, this.loading = !1, this.callbacks.forEach((t) => {
      t(this.onerrorEvent);
    }), this.callbacks = [];
  }
  execute() {
    if (this.resetIfRetryingFailed(), !this.loading)
      if (this.done)
        this.callback();
      else {
        if (window.google && window.google.maps && window.google.maps.version) {
          console.warn("Google Maps already loaded outside @googlemaps/js-api-loader. This may result in undesirable behavior as options and script parameters may not match."), this.callback();
          return;
        }
        this.loading = !0, this.setScript();
      }
  }
}
const $ = `#graphql
query GetStoreAvailability($handle: String!) {
  product(handle: $handle) {
    variants(first: 1) {
      nodes {
        storeAvailability(first:50) {
          nodes {
            available
            pickUpTime
            location {
              name
              id
              address {
                formatted
                latitude
                longitude
              }
              metafield(namespace: "custom", key: "store") {
                reference {
                  ... on Metaobject {
                    id
                    onlineStoreUrl
                    fields {
                      key
                      value
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`;
class K extends x(
  U
) {
  constructor() {
    var t, e;
    super(), this.variantAvailability = [], this.userLocation = null, this.storeHoursJSON = [], this.variantAvailability = [], this.locationInput = this.querySelector("#pickup-location-input"), this.locationButton = this.querySelector("#set-location"), this.locationSubmit = this.querySelector("#pickup-location-submit"), this.userLocation = M.hasValues() ? M.get() : null, this.searchFormToggle = this.querySelector("#pickup-search-toggle"), this.searchedZipCode = this.querySelector("#pickup-zip-code"), this.pickupHandle = "", this.storeHoursJSON = JSON.parse(
      ((t = document.querySelector("#pickupHoursData")) == null ? void 0 : t.textContent) || "[]"
    ), this.productHandle = this.getAttribute("handle") || "", this.googleAPILoaded = !1, this.isTudor = (e = this.productHandle) == null ? void 0 : e.includes("tudor");
  }
  setFormattedAddressAndLocation(t, e, o) {
    this.setUserLocation(t, e), this.toggleFormSuccess(o), this.locationInput && (this.locationInput.value = o);
  }
  async setLocationFromGoogle(t) {
    const e = window.google, o = new e.maps.Geocoder();
    return new Promise((r, i) => {
      o.geocode({ address: t }, (s, n) => {
        var a;
        if (n === e.maps.GeocoderStatus.OK && s && s.length > 0) {
          const l = s[0], c = l.geometry.location, d = c.lat(), u = c.lng(), g = l.formatted_address, p = (a = s[0].address_components.find(
            (f) => f.types.includes("postal_code")
          )) == null ? void 0 : a.short_name;
          this.setFormattedAddressAndLocation(
            d,
            u,
            p || g
          ), this.locationInput && (this.locationInput.value = g), r();
        } else
          this.removeAttribute("data-loading"), i("Geocoding failed for the selected address.");
      });
    });
  }
  async getLocationFromInput() {
    if (!this.locationInput) return;
    const t = this.locationInput.value.trim();
    t && (this.setAttribute("data-loading", ""), await this.setLocationFromGoogle(t), this.sortStoresByLocation());
  }
  async calculateDistance(t, e, o, r) {
    const i = window.google, s = new i.maps.LatLng(t, e), n = new i.maps.LatLng(o, r), a = new i.maps.DistanceMatrixService();
    return new Promise((l, c) => {
      a.getDistanceMatrix(
        {
          origins: [s],
          destinations: [n],
          travelMode: i.maps.TravelMode.DRIVING,
          unitSystem: i.maps.UnitSystem.IMPERIAL
        },
        (d, u) => {
          var g, p;
          if (u === i.maps.DistanceMatrixStatus.OK) {
            if (d) {
              const m = ((p = (g = d.rows[0].elements[0]) == null ? void 0 : g.distance) == null ? void 0 : p.value) / 1609.34;
              l(m);
            }
          } else
            c(`Error calculating distance: ${u}`);
        }
      );
    });
  }
  setUserLocation(t, e) {
    this.userLocation = {
      lat: t,
      lng: e
    }, M.set(this.userLocation);
  }
  async getUserLocation() {
    navigator.geolocation && (this.setAttribute("data-loading", ""), navigator.geolocation.getCurrentPosition(async (t) => {
      const { latitude: e, longitude: o } = t.coords, r = window.google, i = new r.maps.Geocoder(), s = new r.maps.LatLng(e, o);
      await i.geocode({ location: s }, async (n, a) => {
        var l;
        if (a === r.maps.GeocoderStatus.OK && n && n.length > 0) {
          const c = n[0].formatted_address, d = (l = n[0].address_components.find(
            (u) => u.types.includes("postal_code")
          )) == null ? void 0 : l.short_name;
          this.setFormattedAddressAndLocation(
            e,
            o,
            d || c
          );
        }
      }).then(() => {
        this.sortStoresByLocation();
      });
    }));
  }
  checkStorePreference(t) {
    const e = t.location.id.split("/").pop();
    return this.pickupHandle && e && (t.is_preferred_store = e.toString() === this.pickupHandle), t;
  }
  async sortStoresByLocation() {
    if (!this.userLocation) return;
    const t = await Promise.all(
      this.variantAvailability.map(async (e) => {
        const o = await this.calculateDistance(
          this.userLocation.lat,
          this.userLocation.lng,
          e.location.address.latitude,
          e.location.address.longitude
        );
        return {
          ...e,
          distance: o
        };
      })
    );
    t.sort((e, o) => e.distance - o.distance), this.displayStores(t), this.removeAttribute("data-loading");
  }
  getStoreHours(t) {
    if (!this.storeHoursJSON) return "";
    const e = this.storeHoursJSON.find(
      (o) => o.id.toString() === t
    );
    return e ? e.store_hours.trim() : "";
  }
  displayStores(t) {
    const e = this.querySelector("#pickup-availability-list");
    if (e && "content" in document.createElement("template")) {
      const o = document.querySelector(
        "#store-template"
      );
      e.innerHTML = "";
      const r = (i) => {
        i && i.tagName.toLowerCase() == "hr" && i.classList.add("md:block");
      };
      t.forEach((i) => {
        i = this.checkStorePreference(i);
        const s = i.location.metafield.reference.fields.reduce(
          (w, { key: F, value: C }) => (w[F] = C, w),
          {}
        ), n = o.content.cloneNode(!0), a = n.querySelector(
          "[data-pickup-location]"
        ), l = n.querySelector("[data-store-title]"), c = n.querySelector(
          "[data-pickup-distance]"
        ), d = n.querySelector(
          "[data-pickup-status]"
        ), u = n.querySelector("[data-pickup-time]"), g = n.querySelector("[data-store-address]"), p = n.querySelector("[data-store-links]"), f = n.querySelector("[data-store-phone]"), m = n.querySelector(
          "[data-store-directions]"
        ), y = n.querySelector(
          "[data-request-appointment]"
        ), k = n.querySelector(
          "[data-select-location]"
        ), L = n.querySelector("[data-store-hours]");
        let S = !1;
        const b = i.location.id.split("/").pop(), A = i.location.metafield.reference.onlineStoreUrl, P = this.getStoreHours(b), T = s.temporarily_closed;
        if (a && (a.setAttribute("location-title", s.title), a.setAttribute("pickup-hours", P), a.setAttribute("store-url", A), a.setAttribute("pickup-id", b), i.is_preferred_store && (S = !0, a.setAttribute("data-is-selected", "")), (!i.available && this.isTudor || T == "true") && (S = !0, a.setAttribute("data-unavailable", ""))), l && (l.innerText = s.title), i.distance) {
          const w = i.distance > 10 ? Math.floor(i.distance) : i.distance.toFixed(2);
          c && (c.innerText = i.distance ? `${w} miles` : "");
        }
        if (d)
          if ((i.available || !this.isTudor) && T != "true") {
            if (d.innerHTML = '<span class="text-brand-success font-normal">Pickup available</span>', u) {
              const w = u.dataset.defaultPickupTime;
              !i.available && w ? u.innerText = w : u.innerText = i.pickUpTime;
            }
          } else
            d.innerHTML = '<span class="text-brand-dark font-normal">Pickup Unavailable</span>';
        L && (L.innerHTML = P || ""), g && i.location.address && (g.innerHTML = i.location.address.formatted.join("<br>"));
        const q = f && s.phone, E = y && s.formspree_id, _ = m && s.directions;
        q && E && _ && (p == null || p.classList.add("justify-between")), q && (f.classList.remove("hidden"), f.setAttribute("href", `tel:${s.phone}`), f.innerText = s.phone, (_ || E) && r(f.nextElementSibling)), _ && (m.classList.remove("hidden"), m.setAttribute("href", s.directions), m.innerText = "Get Directions", E && r(m.nextElementSibling)), E && (y.classList.remove("hidden"), y.setAttribute(
          "href",
          `${A}#${s.formspree_id}`
        ), y.innerText = "Request Appointment"), k && (k.disabled = S), e.appendChild(n);
      });
    }
  }
  toggleFormSuccess(t) {
    this.removeAttribute("data-show-form"), this.setAttribute("data-search-performed", ""), this.searchedZipCode && (this.searchedZipCode.innerText = t);
  }
  async loadGoogleMapsAPI() {
    await new v({
      apiKey: "AIzaSyBOaOvXv7YstMweTdQkI1uQXpsqGQaiXIA",
      version: "weekly",
      libraries: ["places"]
    }).importLibrary("maps");
    const e = window.google;
    if (!e || !e.maps)
      throw new Error("Google Maps API did not load properly.");
  }
  addEventListeners() {
    this.locationInput && (this.locationInput.addEventListener("change", () => {
      this.getLocationFromInput();
    }), this.locationInput.addEventListener("keypress", (t) => {
      t.key === "Enter" && (t.preventDefault(), this.getLocationFromInput());
    })), this.locationSubmit && this.locationInput && this.locationSubmit.addEventListener("click", () => {
      this.getLocationFromInput();
    }), this.locationButton && this.locationButton.addEventListener("click", () => {
      this.getUserLocation();
    }), this.searchFormToggle && this.searchFormToggle.addEventListener("click", () => {
      this.toggleAttribute("data-show-form");
    });
  }
  setUpModalListener() {
    new URLSearchParams(window.location.search).get("modals") === "pickup-availability" && !this.googleAPILoaded && this.loadGoogleMapsAPI().then(() => {
      this.initializePickupModal();
    }), document == null || document.addEventListener("modal-dialog::open", (o) => {
      const i = o.detail;
      !this.googleAPILoaded && i == "pickup-availability" && this.loadGoogleMapsAPI().then(() => {
        this.initializePickupModal();
      });
    });
  }
  initializePickupModal() {
    if (this.addEventListeners(), this.googleAPILoaded = !0, this.userLocation) {
      const t = window.google, e = new t.maps.Geocoder(), o = new t.maps.LatLng(
        this.userLocation.lat,
        this.userLocation.lng
      );
      e.geocode({ location: o }, (r, i) => {
        var s;
        if (i === t.maps.GeocoderStatus.OK && r && r.length > 0) {
          if (!this.userLocation) return;
          const n = r[0].formatted_address, a = (s = r[0].address_components.find(
            (l) => l.types.includes("postal_code")
          )) == null ? void 0 : s.short_name;
          this.setFormattedAddressAndLocation(
            this.userLocation.lat,
            this.userLocation.lng,
            a || n
          );
        }
      }), this.sortStoresByLocation();
    }
  }
  async getLocationsFromVariant() {
    const t = await this.$api.client.storefront({
      body: {
        query: $,
        variables: {
          handle: this.productHandle
        }
      }
    });
    this.variantAvailability = t.product.variants.nodes[0].storeAvailability.nodes;
  }
  async init(t) {
    await this.getLocationsFromVariant(), t && (this.pickupHandle = t), this.displayStores(this.variantAvailability), this.setUpModalListener();
  }
}
export {
  K as PickupLocator
};
